import React from 'react';
import { Box, Button, IconButton, TextField } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import MaterialTable from 'material-table';
import useProductsEntryManagementStore, { productsEntryManagementStore } from 'stores/productsEntryManagement.store';
import localization from 'utils/materialTableLocalization';
import CloseIcon from '@material-ui/icons/Close';
import { CartItem } from 'interfaces/productEntryManagement.interface';
import { ImProduct } from 'interfaces/imProduct.interface';
import shallow from 'zustand/shallow';

const ImProductEntryManagementProductList: React.FC = () => {
  const [searchText, setSearchText] = productsEntryManagementStore(
    (state) => [state.searchText, state.setSearchText],
    shallow
  );
  const {
    isLoadingProducts,
    products,
    getProducts,
    resetProducts,
    cartItems,
    setCartItems,
    incrementCartItemCount
  } = useProductsEntryManagementStore();

  const addItemsToCart = (productsToAdd: ImProduct[]) => {
    const cartItemsToAdd: CartItem[] = [...cartItems];
    for (let index = 0; index < productsToAdd.length; index++) {
      const p = productsToAdd[index];
      const itemToAdd = cartItemsToAdd.find((ci) => ci.sku === p.sku);

      if (!itemToAdd) {
        const count = incrementCartItemCount();
        cartItemsToAdd.push({
          order: count,
          name: p.name,
          sku: p.sku,
          parentId: p.parentId,
          productId: p.productId,
          quantity: 1
        } as CartItem);
      } else {
        itemToAdd.quantity += 1;
      }
    }
    setCartItems(cartItemsToAdd);
  };
  return (
    <>
      <div style={{ borderBottom: '1px solid #cacaca', padding: '15px 0', backgroundColor: 'white' }}>
        <Box display="flex" justifyContent="center" alignItems="center" px={4}>
          <TextField
            autoFocus
            variant="outlined"
            margin="dense"
            id="input-search"
            name="Search"
            label="Buscar"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                getProducts(1, 250, searchText);
              }
            }}
            InputProps={{
              autoFocus: true,
              autoComplete: 'off',
              endAdornment: (
                <IconButton
                  size="small"
                  onClick={() => {
                    setSearchText('');
                    resetProducts();
                  }}
                >
                  <CloseIcon />
                </IconButton>
              )
            }}
            fullWidth
          />
          <Button
            variant="contained"
            size="medium"
            color="primary"
            style={{ marginLeft: '10px', width: '140px' }}
            onClick={() => getProducts(1, 20, searchText)}
          >
            BUSCAR
          </Button>
          <Button
            variant="contained"
            size="medium"
            color="primary"
            style={{ marginLeft: '20px', width: '140px' }}
            onClick={() => addItemsToCart(products)}
            startIcon={<AddIcon />}
          >
            Todos
          </Button>
        </Box>
      </div>
      <MaterialTable
        title="Lista de productos"
        columns={[
          {
            title: 'Producto',
            field: 'name'
          },
          {
            title: 'SKU',
            field: 'sku'
          },
          {
            title: 'Tipo',
            field: 'type'
          },
          {
            title: 'Cantidad',
            field: 'stock'
          }
        ]}
        data={products}
        isLoading={isLoadingProducts}
        localization={localization}
        options={{
          draggable: false,
          pageSize: 10,
          actionsColumnIndex: -1,
          toolbar: false,
          rowStyle: {
            fontSize: 12
          }
        }}
        actions={[
          {
            icon: 'add',
            tooltip: 'Save User',
            onClick: (event, rowData) => {
              addItemsToCart([rowData as ImProduct]);
            }
          }
        ]}
      />
    </>
  );
};

export default ImProductEntryManagementProductList;
